import { forwardRef, useEffect, useImperativeHandle } from "react";
import Table from "../Table";
import useTable from "./hook";
import type { DataChanged, ReceivedPropsForForm } from "./hook";
import { Styles } from "./styled";

export type TableFormRef = {
  getChangedData: () => DataChanged;
  resetChangedData: () => void;
  discardChanges: () => void;
  addRows: (count: number) => void;
};

const TableFormLayout = (props: ReturnType<typeof useTable>) => {
  return (
    <Styles className={`${props.isEditMode ? "is-in-edit-mode" : ""}`}>
      <Table {...props} />
    </Styles>
  );
};

const TableForm = forwardRef<TableFormRef, ReceivedPropsForForm>(
  (props, ref) => {
    const tableProps = useTable(props);

    useImperativeHandle(
      ref,
      () => ({
        getChangedData: tableProps.getChangedData,
        resetChangedData: tableProps.resetChangedData,
        discardChanges: tableProps.discardChanges,
        addRows: tableProps.addRows,
      }),
      [
        tableProps.getChangedData,
        tableProps.resetChangedData,
        tableProps.discardChanges,
        tableProps.addRows,
      ],
    );

    return <TableFormLayout {...tableProps} />;
  },
);

TableForm.displayName = "TableForm";

export default TableForm;
